"use client"

import { FiCheckCircle, FiAlertCircle, FiInfo, FiX } from "react-icons/fi"

const NotificationSystem = ({ notifications, removeNotification }) => {
  const getNotificationIcon = (type) => {
    switch (type) {
      case "success":
        return <FiCheckCircle className="w-5 h-5" />
      case "error":
        return <FiAlertCircle className="w-5 h-5" />
      default:
        return <FiInfo className="w-5 h-5" />
    }
  }

  const getNotificationStyles = (type) => {
    switch (type) {
      case "success":
        return "bg-green-500/10 border-green-500/30 text-green-300"
      case "error":
        return "bg-red-500/10 border-red-500/30 text-red-300"
      default:
        return "bg-blue-500/10 border-blue-500/30 text-blue-300"
    }
  }

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`flex items-center gap-3 p-4 rounded-lg border backdrop-blur-sm animate-in slide-in-from-right-full duration-300 ${getNotificationStyles(notification.type)}`}
        >
          {getNotificationIcon(notification.type)}
          <div className="flex-1">
            <p className="font-medium">{notification.title}</p>
            {notification.message && <p className="text-sm opacity-80">{notification.message}</p>}
          </div>
          <button
            onClick={() => removeNotification(notification.id)}
            className="opacity-60 hover:opacity-100 transition-opacity"
          >
            <FiX className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  )
}

export default NotificationSystem
